export const defaultState = {
  remoteMemberAssociation: null,
  memberAssociation: null,
  levelDomain: null,
  validFrom: null,
  validTo: null,
  status: null,
};

const UPDATE_FIELD = 'UPDATE_FIELD';
const SET_EDIT_DATA = 'SET_EDIT_DATA';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });
export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      remoteMemberAssociation: action.payload.remoteMemberAssociation?.id,
      memberAssociation: action.payload.memberAssociation?.id,
      levelDomain: action.payload.levelDomain?.id,
      validFrom: action.payload.validFrom ? new Date(action.payload.validFrom) : undefined,
      validTo: action.payload.validTo ? new Date(action.payload.validTo) : undefined,
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
